// extracted by mini-css-extract-plugin
module.exports = {"headline":"PoSubmitSuccess_headline__1vuEQ","text":"PoSubmitSuccess_text__RxAQw"};